import { last } from 'lodash';
import { useEffect, useRef } from 'preact/hooks';

export const getIconVisibility = (isVisible: boolean): { [key: string]: string | number } => ({
	visibility: isVisible ? 'visible' : 'hidden'
});

export const focusToAriaElement = (containerRef): void => {
	const ariaFocusElements = containerRef.current.getElementsByClassName('aria-focus');

	if (ariaFocusElements.length) {
		(last(ariaFocusElements) as HTMLElement).focus();
	}
};

export const useAriaFocusRef = <T>(initialValue?: T | null) => {
	const containerRef = useRef<T>(initialValue);

	useEffect(() => {
		if (containerRef.current) {
			focusToAriaElement(containerRef);
		}
	}, [containerRef]);

	return containerRef;
};
